// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__NTz8i","location":"LocationSection_location__qTq1M"};